module.exports = __webpack_public_path__ + "img/img-registration-one@3x.fb1e124f.png";